import _ from "lodash"
import { fromJS } from "immutable"
import { compose } from "lodash/fp"
import Payment from "@kiwicom/frontend-app/scripts/containers/mutable/Payment"

import AdditionalService from "common/records/AdditionalService"
import { mapToUtcMoment } from "common/services/momentHelpers/momentHelpers"
import {
  API_CATEGORIES_TO_SERVICES,
  SERVICES,
  SERVICES_STATUSES,
} from "mmb/consts/additionalServices"
import { API_CATEGORIES } from "mmb/consts/booking"
import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"

export default function mapperManageBookingChange(input) {
  const params = {
    id: input.abid,
    created: mapToUtcMoment(input.booked),
    status: input.final_status, // API is returning final_status: expired even when there is no payment_token yet
    payment: new Payment({
      gate: input.payment_gate,
      // Is set only when requested, otherwise null
      // when payment_token && final_status != "open", throw it away, so we can request new
      token: input.payment_token,
      currency: input.payment_currency && input.payment_currency.toLowerCase(),
      credits: input.credits_payment_amount,
      // TODO: that's not right, credits can be used together with normal payment... payment = payment_price + credits_payment_amount
      amount: input.payment_gate === "credits" ? input.price : input.payment_price,
      expiration: input.payment_expiration ? mapToUtcMoment(input.payment_expiration) : null,
      created: input.payment_token_created ? mapToUtcMoment(input.payment_token_created) : null,
    }),
  }

  if (!API_CATEGORIES_TO_SERVICES[input.category])
    cuckoo.error(cuckooEvents.MMB_MAPPER_SERVICES_UNKNOWN_CATEGORY, {
      category: input.category,
    })

  if (input.category === API_CATEGORIES.UPDATE_INSURANCES) {
    return new AdditionalService({
      ...params,
      category: SERVICES.INSURANCE,
      params: input.data.data, // superugly, force backend to change this
    })
  }
  if (
    input.category === API_CATEGORIES.EXTRA_BAGS ||
    input.category === API_CATEGORIES.SERVICE_BAGGAGE ||
    input.bags
  ) {
    return new AdditionalService({
      ...params,
      category: SERVICES.BAGGAGE,
      description: input.comment,
      params: {
        bags: input.bags, // backend sends 0
      },
    })
  }
  if (input.flights) {
    // We don't need other data here, as we use data from flight_history
    return new AdditionalService({ ...params, category: SERVICES.CHANGE_FLIGHTS })
  }
  if (input.category === API_CATEGORIES.EXTRAS_CHANGE_FLIGHT) {
    return new AdditionalService({
      ...params,
      category: SERVICES.CHANGE_FLIGHTS,
      description: input.comment,
    })
  }
  if (input.category === API_CATEGORIES.PASSENGER_EDIT) {
    return new AdditionalService({ ...params, category: SERVICES.PASSENGER_EDIT })
  }
  if (input.category === API_CATEGORIES.MEALS) {
    return new AdditionalService({
      ...params,
      category: SERVICES.MEALS,
      params: fromJS(input.data),
    })
  }
  if (input.category === API_CATEGORIES.SERVICE_MEALS_ON_BOARD) {
    return new AdditionalService({
      ...params,
      category: SERVICES.OFFERED_MEALS,
      params: fromJS(input.data),
    })
  }
  if (input.category === API_CATEGORIES.PRICE_CHANGE) {
    return new AdditionalService({
      ...params,
      category: SERVICES.PRICE_CHANGE,
      description: input.comment,
    })
  }
  if (input.category === API_CATEGORIES.FLIGHTS) {
    return new AdditionalService({
      ...params,
      category: SERVICES.SCHEDULE_CHANGE,
    })
  }
  if (input.category && _.startsWith(input.category, "service")) {
    // pending additional service
    return new AdditionalService({
      ...params,
      description: input.comment,
      category: input.category.replace("service.", ""),
    })
  }
  if (input.category === "seating" && input.data) {
    return new AdditionalService({
      ...params,
      category: SERVICES.SEATING,
      params: fromJS({ requestedSeats: input.data }),
    })
  }
  if (input.comment) {
    // When there is bags == 0 and there is some comment => it means that this change was created manually by some booker
    return new AdditionalService({
      ...params,
      category: SERVICES.EXTRA,
      description: input.comment,
    })
  }
  if (input.category === API_CATEGORIES.ASSISTED_REFUND) {
    return new AdditionalService({ ...params, category: SERVICES.ASSISTED_REFUND })
  }

  return new AdditionalService({
    category: SERVICES.EXTRA,
    ...params,
  })
}

export const mapperCreatedBookingChange = compose(
  mapperManageBookingChange,
  input => ({
    ...input,
    final_status: SERVICES_STATUSES.CREATED,
  }),
)
